import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "mMenu",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "taskCount"]),
    route() {
      return this.$route.path;
    }
  },
  data() {
    const menu = [{
      label: "HOME",
      icon: "menu-home",
      path: "/"
    }, {
      label: "EARN",
      icon: "menu-earn",
      path: "/appcenter"
    },
    // {
    //   label: "STUDY",
    //   icon: "menu-study",
    //   path: "/mine",
    // },
    {
      label: "GAME",
      icon: "menu-game",
      path: "/game"
    }, {
      label: "REWARDS",
      icon: "menu-tasks",
      path: "/earn"
    }
    // {
    //   label: "AIRDROP",
    //   icon: "menu-airdrop",
    //   path: "/airdropSecond",
    // },
    // {
    //   label: "NFT",
    //   icon: "menu-nft",
    //   path: "/nfts",
    // },
    ];

    return {
      menu
    };
  },
  methods: {
    onSkip(page, id) {
      console.log("33334444", page);
      this.$nextTick(() => {
        this.$router.push(page);
      });
    }
  },
  mounted() {
    this.setWowAnim();
    //this.loadTaskCount();
  }
};